import React from 'react';

const SettingsContent: React.FC = () => {
    return (
        <div>
            <h1 className="text-2xl font-bold mb-4 text-copy-primary">Settings</h1>
            <p className="text-copy-primary">Configure your billing dashboard settings:</p>
            
            {/* Example future placeholders */}
            <div className="grid grid-cols-3 gap-4 mt-6">
                <div className="bg-white p-4 shadow rounded">General Settings</div>
                <div className="bg-white p-4 shadow rounded">Payment Settings</div>
                <div className="bg-white p-4 shadow rounded">Security Settings</div>
            </div>
        </div>
    );
};

export default SettingsContent;
